// extracted by mini-css-extract-plugin
module.exports = {"matchTitle":"SportFeedItem_matchTitle__RM7uR","matchInfo":"SportFeedItem_matchInfo__3Qhax"};